module.exports = __webpack_public_path__ + "img/logo-ppt.19c1068b.png";